export default __webpack_public_path__ + "static/media/allison_hempenstall.d3981609.jpg";